import { ca } from '@cian/analytics';

export function trackAdvantagesBlock() {
  ca('eventSite', {
    action: 'show',
    label: 'Banner_advantages',
    category: 'Mortgage',
    name: 'oldevent',
  });
}
